import { render, staticRenderFns } from "./RegistrarPontoEmpresas.vue?vue&type=template&id=16f2602a"
import script from "./RegistrarPontoEmpresas.vue?vue&type=script&lang=js"
export * from "./RegistrarPontoEmpresas.vue?vue&type=script&lang=js"
import style0 from "./RegistrarPontoEmpresas.vue?vue&type=style&index=0&id=16f2602a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports